import { UserManager, User } from 'oidc-react';

import makeAPIRequest from 'lib/api-client';
import { updateProfilePicture } from 'core/data/profile/query';
import { userManager } from '../../../../config';

export interface SignupUser {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  receiveEmails: boolean;
  secret: string;
}

export async function signup(
  user: SignupUser,
  profilePicture?: Blob,
): Promise<boolean> {
  const res = await makeAPIRequest('/signup', user, 'POST');
  if (res.status !== 200) {
    return false;
  }
  // use the returned access token to semi-login to the oidc user
  const tokenUser = User.fromStorageString(
    `{"access_token": "${res.body.access_token}"}`,
  );
  userManager.storeUser(tokenUser);

  if (profilePicture) {
    const data = await updateProfilePicture(profilePicture);
  }

  return true;
}

export default undefined;
